import { useMutation, useQuery } from "@tanstack/react-query";
import { getData, postData } from "../request/api";
import { toast } from "sonner";

interface Contact {
  name: string;
  email: string;
  message: string;
  phone: string;
}

export const useGetAboutUs = () => {
  return useQuery({
    queryKey: ["about"],
    queryFn: async () => {
      const response = await getData("about");
      return response.data;
    },
    staleTime: 60 * 60 * 1000 * 10,
    gcTime: 60 * 60 * 1000 * 10,
    retry: 2,
  });
};

export const useGetWhyChoose = () => {
  return useQuery({
    queryKey: ["why-choose"],
    queryFn: async () => {
      const response = await getData("why-choose");
      return response.data;
    },
    staleTime: 60 * 60 * 1000 * 10,
    gcTime: 60 * 60 * 1000 * 10,
    retry: 2,
  });
};

export const useGetCycle = () => {
  return useQuery({
    queryKey: ["cycle"],
    queryFn: async () => {
      const response = await getData("cycle");
      return response.data;
    },
    staleTime: 60 * 60 * 1000 * 10,
    gcTime: 60 * 60 * 1000 * 10,
    retry: 2,
  });
};

export const useGetVision = () => {
  return useQuery({
    queryKey: ["vision"],
    queryFn: async () => {
      const response = await getData("vision");
      return response.data;
    },
    staleTime: 60 * 60 * 1000 * 10,
    gcTime: 60 * 60 * 1000 * 10,
    retry: 2,
  });
};

export const useGetServices = () => {
  return useQuery({
    queryKey: ["services"],
    queryFn: async () => {
      const response = await getData("services");
      return response.data;
    },
    staleTime: 60 * 60 * 1000 * 10,
    gcTime: 60 * 60 * 1000 * 10,
    retry: 2,
  });
};

export const useGetSolutions = () => {
  return useQuery({
    queryKey: ["solutions"],
    queryFn: async () => {
      const response = await getData("solutions");
      return response.data;
    },
    staleTime: 60 * 60 * 1000 * 10,
    gcTime: 60 * 60 * 1000 * 10,
    retry: 2,
  });
};
export const useGetFounder = () => {
  return useQuery({
    queryKey: ["founders"],
    queryFn: async () => {
      const response = await getData("founders");
      return response.data;
    },
    staleTime: 60 * 60 * 1000 * 10,
    gcTime: 60 * 60 * 1000 * 10,
    retry: 2,
  });
};

export const useContactFormSubmission = () => {
  return useMutation({
    mutationKey: ["contact-form-submission"],
    mutationFn: async (formData: Contact) => {
      const response = await postData("contact", formData);
      return response.data;
    },
    onSuccess: (res) => {
      toast.success(res.message || "Message sent successfully!");
    },
    onError: (error: any) => {
      toast.error(
        error.response?.data?.message ||
          "Failed to send message. Please try again.",
      );
    },
  });
};
